<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm :default-values="{}"
                      title="Create aggr config"
                      @finish="handleItemsUpdate"
                      create
            >
              <template #button="{onclick}">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
            </EditForm>
          </div>
        </div>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :empty-text="emptyText"
                    show-empty
                    :busy="!!cancel"
                    :items="items"
                    :fields="fields"
                >
                  <template #cell(actions)="row">
                    <EditForm
                        :default-values="{...row.item}"
                        title="Edit aggr config"
                        @finish="handleItemsUpdate"
                    />
                    <RemoveForm :object="row.item.key"
                                message="Please confirm removing aggr config"
                                :url="'/api/v1/aggr-config/' + row.item.id"
                                @finish="handleItemsUpdate"
                    />
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination
                    class="float-right"
                    v-model="pagination.page"
                    :total-rows="pagination.records"
                    :per-page="pagination.onPage"
                    @change="onPageChange"
                    first-number
                    last-number
                ></b-pagination>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <ve-pagination
                    class="float-right"
                    :page-index="pagination.page"
                    :page-size="pagination.onPage"
                    :total="pagination.records"
                    :pagingCount="pagination.count"
                    :layout="['total', 'sizer']"
                    :pageSizeOption="pagination.pageSizeOption"
                    @on-page-size-change="onPageSizeChange"
                />
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import EditAggrConfigForm from "../../components/AggrConfigs/EditAggrConfigForm";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import axios from "axios";
import {getRouteIcon, ROUTE_AGGR_CONFIGS} from "../../utils/routerIcons";

function getDefaultPagination() {
  return {
    onPage: 10,
    page: 1,
    records: 0,
    count: 5,
    pageSizeOption: [10,25,50,100,200],
  };
}

function getDefaultSort() {
  return {
    column: 'id',
    order: 'ASC',
  };
}

export default {
  components: {
    EditForm: EditAggrConfigForm,
    RemoveForm,
  },
  data() {
    return {
      showEmpty: false,
      showError: false,
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: '_ID', },
        { key: 'key', label: 'Key', },
        {
          key: 'value',
          label: 'Value',
          formatter: (value) => {
            const txt = JSON.stringify(value);
            return txt.length <= 23 ? txt : `${txt.substr(0, 20)}...`;
          },
        },
        { key: 'actions', label: 'Actions' }
      ],
      items: [],
      sorts: getDefaultSort(),
      filters: {},
      pagination: getDefaultPagination(),
    }
  },
  computed: {
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_AGGR_CONFIGS),
  },
  methods: {
    handleItemsUpdate() {
      this.loadItems();
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      let self = this;
      loadingInstance.show();

      this
          .$http({
            url: '/api/v1/aggr-config',
            params: {
              // pagination
              limit: this.pagination.onPage,
              offset: this.pagination.onPage * (this.pagination.page - 1),

              // sort params
              orderBy: this.sorts.column,
              direction: this.sorts.order,
            },
            method: 'GET',
            cancelToken: new axios.CancelToken(c => {self.cancel = c})
          })
          .then(resp => {
            let {items, pagination} = resp.data;
            let {limit, totalCount} = pagination;

            this.items = items;
            this.pagination.onPage = limit;
            this.pagination.records = totalCount;
          })
          .catch((err) => {
            this.items = [];
            this.error = err;
          })
          .finally(() => {
            loadingInstance.close();
            this.cancel = null;
          });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
    onFinishEdit() {
      this.loadItems();
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>
